import { render, staticRenderFns } from "./TagsDropdownMenu.vue?vue&type=template&id=07eeb406"
import script from "./TagsDropdownMenu.vue?vue&type=script&lang=js"
export * from "./TagsDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports